(function() {
  var MOBILE_MAX = 749;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function scrollToVisibleMedia(stage) {
    if (!stage || !isMobile()) return;

    var current = stage.querySelector(
      '[data-product-single-media-wrapper]:not(.hide)'
    );
    if (!current) return;

    var gutter = parseFloat(getComputedStyle(stage).paddingLeft) || 0;

    stage.scrollTo({
      left: current.offsetLeft - gutter,
      behavior: 'auto'
    });
  }

  function initStages() {
    document
      .querySelectorAll('.product-single__media-stage')
      .forEach(scrollToVisibleMedia);
  }

  document.addEventListener('mediaVisible', function(event) {
    var stage = event.target.closest('.product-single__media-stage');
    scrollToVisibleMedia(stage);
  });

  function initQuantitySelectors() {
    document.querySelectorAll('[data-quantity-selector]').forEach(function(wrapper) {
      var input = wrapper.querySelector('[data-quantity-input]');
      var minus = wrapper.querySelector('[data-quantity-minus]');
      var plus = wrapper.querySelector('[data-quantity-plus]');
      if (!input || !minus || !plus) return;

      function setQuantity(next) {
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var value = Math.max(min, parseInt(next, 10) || min);
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      minus.addEventListener('click', function() {
        setQuantity((parseInt(input.value, 10) || 1) - 1);
      });

      plus.addEventListener('click', function() {
        setQuantity((parseInt(input.value, 10) || 1) + 1);
      });
    });
  }

  function init() {
    initStages();
    initQuantitySelectors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
